import fetch from 'utils/fetch'

export function getGeneListCount (data) {
  return fetch({
    url: `${process.env.ODS_DISPLAY_API}/ods/display/getGeneListCount`,
    method: 'post',
    data
  })
}
export function getGeneList (data) {
  return fetch({
    url: `${process.env.ODS_DISPLAY_API}/ods/display/getGeneList`,
    method: 'post',
    data
  })
}
export function getProteinList (data) {
  return fetch({
    url: `${process.env.ODS_DISPLAY_API}/ods/display/getProteinList`,
    method: 'post',
    data
  })
}
export function getProteinListCount (data) {
  return fetch({
    url: `${process.env.ODS_DISPLAY_API}/ods/display/getProteinListCount`,
    method: 'post',
    data
  })
}
export function getPeptideList (data) {
  return fetch({
    url: `${process.env.ODS_DISPLAY_API}/ods/display/getPeptideList`,
    method: 'post',
    data
  })
}
export function getPeptideListCount (data) {
  return fetch({
    url: `${process.env.ODS_DISPLAY_API}/ods/display/getPeptideListCount`,
    method: 'post',
    data
  })
}
export function getFractionPeptideList (data) {
  return fetch({
    url: `${process.env.ODS_DISPLAY_API}/ods/display/getFractionPeptideList`,
    method: 'post',
    data
  })
}
export function getProteinDetail (data) {
  return fetch({
    url: `${process.env.ODS_DISPLAY_API}/ods/display/getProteinDetail`,
    method: 'post',
    data
  })
}
export function getModificationListByPeptideId (data) {
  return fetch({
    url: `${process.env.ODS_DISPLAY_API}/ods/display/getModificationListByPeptideId`,
    method: 'post',
    data
  })
}
export function getProteinListByPeptideId (data) {
  return fetch({
    url: `${process.env.ODS_DISPLAY_API}/ods/display/getProteinListByPeptideId`,
    method: 'post',
    data
  })
}
export function getGeneListByPeptideId (data) {
  return fetch({
    url: `${process.env.ODS_DISPLAY_API}/ods/display/getGeneListByPeptideId`,
    method: 'post',
    data
  })
}
export function getModificationListByProteinId (data) {
  return fetch({
    url: `${process.env.ODS_DISPLAY_API}/ods/display/getModificationListByProteinId`,
    method: 'post',
    data
  })
}
export function getProteinListByGeneSymbol (data) {
  return fetch({
    url: `${process.env.ODS_DISPLAY_API}/ods/display/getProteinListByGeneSymbol`,
    method: 'post',
    data
  })
}
export function getProcessModificationList (data) {
  return fetch({
    url: `${process.env.ODS_DISPLAY_API}/ods/display/getProcessModificationList`,
    method: 'post',
    data
  })
}

export function getTop10List (data) {
  return fetch({
    url: `/bigdata/stats/getTop10List?dimensionType=sourceTypeDetail`,
    method: 'post'
  })
}

export function getQuantitationDistribution (data) {
  return fetch({
    url: `/bigdata/search/getQuantitationDistribution/${data.type}?dimensionType=sourceTypeDetail&quantitationType=ifot`,
    method: 'post'
  })
}

export function getGeneSymbolFuzzy (data) {
  return fetch({
    url: `/bigdata/search/getGeneSymbolFuzzy/${data.keyWord}`,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/ods.js